<script>
import { signUpNewsletter } from '../../api/newsletter';
import { emailRegex } from '../../constants';

export default {
  name: 'CpSubscribeToNewsletter',
  components: {
    CpButton: require('../../button').default,
    CpTextInput: require('../../inputs/text').default,
    CpToasted: require('../../toasted').default,
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginTop: require('../../directives/margins').marginTop,
    marginBottom: require('../../directives/margins').marginBottom,
    marginRight: require('../../directives/margins').marginRight,
  },
  data() {
    return {
      email: '',
      loading: false,
      toasted: [],
      errorMessage: '',
    };
  },
  methods: {
    async handleSubscribe() {
      this.errorMessage = '';
      this.loading = true;
      if (this.isSubmitAllowed) {
        this.trackGa4Event('newsletter_subscribe_submit', {
          location: 'home_landing',
          action: 'submit',
        });
        await signUpNewsletter({ email: this.email })
          .then(() => {
            this.trackGa4Event('newsletter_subscribe_success', {
              location: 'home_landing',
              action: 'success',
            });
            this.email = '';
            this.createAlert({ message: 'Successfully subscribed to Daily Newsletter!' });
          })
          .catch(error => {
            console.warn(error);
            this.trackGa4Event('newsletter_subscribe_error', {
              location: 'home_landing',
              action: 'error',
              error_message: error?.message || 'unknown',
            });
            this.createAlert({ message: 'An error has occurred, try again!', theme: 'danger' });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
        this.trackGa4Event('newsletter_subscribe_invalid', {
          location: 'home_landing',
          action: 'submit',
        });
        this.errorMessage = 'A valid email address is required';
      }
    },
    createAlert({ message, theme = 'success', duration = 2000 }) {
      this.toasted.push({ key: `alert-${new Date().toString()}`, message, theme, duration });
    },
  },
  computed: {
    isSubmitAllowed() {
      return emailRegex.test(this.email) && this.email;
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="alerts">
      <CpToasted v-for="toast in toasted" :key="toast.key" :message="toast.message" :theme="toast.theme" :duration="toast.duration" />
    </div>
    <div>
      <img src="https://assets.staging.crowdblue.com/v2/demo/all/img/homepage/newsletter.png" class="img-news" loading="lazy" />
    </div>
    <div class="newsletter-container">
      <h3 class="title-2 primary-color text-left" style="font-size: 39px;">Suscribe to CrowdBlue daily news now</h3>
      <p class="content-2 primary-color text-left" v-margin-top="0">Where your campaign, your voice, and your values belong</p>
      <div class="inputContainer">
        <input :class="{ 'text-input': true, 'input-error': errorMessage }" v-model="email" placeholder="✉️ Your email" v-margin-bottom="0" v-margin-right="0.5" />
        <button @click.prevent="handleSubscribe" :disabled="loading" class="button button-primary plausible-event-name=Sign+Up+Newsletter" data-newsletter-only="true">
          <img v-if="loading" src="https://assets.staging.crowdblue.com/v2/demo/all/img/spin.gif" alt="Loading..." />
          <span v-else>Sign up</span>
        </button>
      </div>
      <p v-if="errorMessage" class="caption error-color text-left"><i class="fas fa-exclamation-circle error-color"></i>&nbsp;{{ errorMessage }}</p>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  width: 100%;
}
.newsletter-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 550px;
  padding-left: 100px;
}
.alerts {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}
.img-news {
  width: 100%;
  height: 100%;
  max-height: 300px;
  object-fit: cover;
  opacity: 0.7;
}
.inputContainer {
  display: flex;
  align-items: center;
}
.inputContainer .text-input {
  border: 1px solid var(--neutral-1);
  border-radius: 8px;
  background: var(--white);
  color: black;
  flex-grow: 1;
  font: inherit;
  width: auto;
  padding: 8px;
}
.inputContainer .text-input:focus {
  border-color: var(--black);
}
.inputContainer .input-error {
  border-color: var(--error);
}
.button {
  flex: 1;
}
</style>
